module.exports = __webpack_public_path__ + "static/media/6.731c01eb.jpg";